export default __webpack_public_path__ + "static/media/andor8.5258e781.jpg";